/**
 * /devhub/activation — Resource activation (operator). Surface Layer (/01). REQ-001.91 Phase 3.
 * Live operator panel (DevHubResourceActivationPanel) wired to its useDevHub* hook over GET /api/control/registry/:name.
 * Operator-only (routePolicy plane guard + DevHubPanelPage self-guard).
 */
import { createFileRoute } from '@tanstack/react-router';
import { DevHubResourceActivationPanel } from '../features/control-plane/DevHubResourceActivationPanel';
import { DevHubPanelPage } from '../components/devhub/DevHubPanelPage';

export const Route = createFileRoute('/devhub/activation')({ component: ActivationPage });

function ActivationPage() {
  return (
    <DevHubPanelPage
      title="Resource activation"
      subtitle="MCP / skill / plugin / superpower activation gates."
      status={{ label: 'live', live: true }}
    >
      <DevHubResourceActivationPanel />
    </DevHubPanelPage>
  );
}
